import dayjs from 'dayjs';
import _ from 'underscore';
import parseError from '../../parseError.js';
import { Toast } from '../../../../../../Components/Notification/index.js';

const updateMeal = async ({ state, userId, editMeal, updateState, refreshPage }) => {
  const { itemDetails } = state;
  const { tourId, mealId, jobElementId,
  OTE, billable, autoAdd } = itemDetails;

  let { mealStartTime, mealEndTime } = itemDetails;

  const parameters = {
    mealId,
    tourId,
    userId,
    startTime: dayjs(mealStartTime).format('YYYY-MM-DD HH:mm:ss'),
    endTime: dayjs(mealEndTime).format('YYYY-MM-DD HH:mm:ss'),
    jobElementId: jobElementId || -1,
    OTE,
    billable,
    autoAdd
  };

  // update meal
  const { resource } = state;
  const date = dayjs(mealStartTime).format('M/D/YYYY (ddd)');
  let notification = {type: 'success', message: 'Meal Updated', description: `For ${resource.name} on ${date}`};
  try {
    await editMeal(parameters);
  }
  catch(error) {
    if (!_.isEmpty(error)) {
      updateState({
        crudError: {
          failedAction: 'editMeal',
          message: parseError(error)
        }
      });
      console.log(error);
      notification = {
        type: 'error',
        message: "Updating Meal Failed",
        description: `For [${resource.name} on ${date}]: ${parseError(error)}`
      };
    }
  }
  Toast(notification);
  refreshPage();
}

export default updateMeal;
